import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllSchedulesForMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetASingleScheduleForMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateAScheduleForMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateScheduleStatus extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/UpdateStatus");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetScheduleListForAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetScheduleListForMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/GetListForMaster");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteScheduleForAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/DeleteForAdmin");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetStudentAbsenceReports extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/GetStudentReports");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllSchedulePayBacks extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/GetAllSchedulePayBack");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class VerifyMasterAbsenceReport extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag(
      "Schedule/VerifyNotHoldingClassByMasterAndPayBackStudentWallet"
    );
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllUserScheduleDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/GetAllUserSchedule");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class GetDicountDayReport extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/GetDicountDayReport");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteSchedulesForAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Schedule/DeleteSchedulesForAdmin");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetAllSchedulesForMaster,
  GetASingleScheduleForMaster,
  UpdateAScheduleForMaster,
  UpdateScheduleStatus,
  GetScheduleListForAdmin,
  GetScheduleListForMaster,
  DeleteScheduleForAdmin,
  GetStudentAbsenceReports,
  VerifyMasterAbsenceReport,
  GetAllSchedulePayBacks,
  GetAllUserScheduleDiscount,
  DeleteSchedulesForAdmin,
  GetDicountDayReport
};
